import React from 'react';
import { permissionObj } from '../../../../Helpers/permission';
import HeadTittle from '../../../../components/HeadTittle';
import {AddIcon, TrashOutlineIcon} from '../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import MainInputTable from "./SubComponents/MainInputTable";
import InputsApp from "./Functionality/InputsApp";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const Inputs = () => {

    const {
        DEV,
        permission,
        deleteModalShow,
        setDeleteModalShow,
        createModalShow,
        setCreateModalShow,
        selectedList,
        setSelectedList
    } = InputsApp();

    return (
        <>
            <HeadTittle name={'inputs'}>
                {(DEV || permission?.includes(permissionObj?.WEB_HID_CREATE)) && (
                    <ButtonAction
                        id='btn_ip_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => {
                            setCreateModalShow(true);
                        }}
                    />
                )}
                {(DEV || permission?.includes(permissionObj?.WEB_HID_DELETE)) && (
                    <ButtonAction
                        id='btn_ip_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteModalShow(true);
                        }}
                    />
                )}
            </HeadTittle>
            <MainInputTable
                selectedList={selectedList}
                setSelectedList={setSelectedList}
                deleteModalShow={deleteModalShow}
                setDeleteModalShow={setDeleteModalShow}
                createModalShow={createModalShow}
                setCreateModalShow={setCreateModalShow}
            />
        </>
    );
};

export default Inputs;
